import { APIScope, LocationVarKey } from "@swivl-mono/types";
import { ReactNode } from "react";

// export interface HideableInterface extends LocationPageInterface{
//     hideIf?: WorksheetCondition;
// }

// export interface WorksheetRow extends HideableInterface{
//     disableIf?: WorksheetCondition;

//     children?:any
//     marginTop?:boolean;
//     marginBottom?:boolean;
// }

export enum Opp {
  EQUAL = "==",
  NOT_EQUAL = "!=",
}

export function IS_EQUAL(variable: LocationVarKey, to: string): WorksheetCondition {
  return { TYPE: "IF", IF: variable, IS: Opp.EQUAL, TO: to };
}
export function IS_NOT_EQUAL(variable: LocationVarKey, to: string): WorksheetCondition {
  return { TYPE: "IF", IF: variable, IS: Opp.NOT_EQUAL, TO: to };
}
export function IS_TRUE(variable: LocationVarKey): WorksheetCondition {
  return { TYPE: "IF", IF: variable, IS: Opp.EQUAL, TO: "1" };
}

export function IF_ANY(conditions: WorksheetCondition[]): WorksheetOrCondition {
  return { TYPE: "OR", OR: conditions };
}
export function IF_ALL(conditions: WorksheetCondition[]): WorksheetAndCondition {
  return { TYPE: "AND", AND: conditions };
}

export interface RouterWorksheetData {
  to: string;
  element?: ReactNode;
  label: string; // For sidebar
  apiScope?: APIScope;
  hideIf?: WorksheetCondition;
  children?: RouterWorksheetData[];
}

export type WorksheetCondition = WorksheetIfCondition | WorksheetOrCondition | WorksheetAndCondition;
export interface WorksheetIfCondition {
  TYPE: "IF";
  IF: LocationVarKey;
  IS: Opp;
  TO: string;
}

export interface WorksheetOrCondition {
  TYPE: "OR";
  OR: WorksheetCondition[];
}
export interface WorksheetAndCondition {
  TYPE: "AND";
  AND: WorksheetCondition[];
}

export enum WorksheetStatus {
  COMPLETE = "Complete",
  NEEDS_REVIEW = "Needs Review",
}

export type DefaultOrCustomType = { [key in LocationVarKey]?: boolean };
